export const getPartsOfArray = (arr, index) => {
  if (typeof index !== 'number' || !Array.isArray(arr)) return arr;

  return index < 0 ? arr.slice(index) : arr.slice(0, index);
};

export const prepareRoutes = (defaultRoutes, accessRoutes) => accessRoutes.map((item, index) => {
  const defaultRoute = defaultRoutes.find((defaultRoute) => defaultRoute.link === `/${item.url}`);
  return {
    ...defaultRoute,
    id: index,
    name: item.label,
    link: `/${item.url}`,
    count: item.count,
  }
});

export const prepareSearchList = (guides, search, originaList) => guides
  .map((article) => {
    const findCategoryName = originaList.find((category) => category.id === article.category_id);
    if (!findCategoryName) return;

    const findIndexContent = article.content.trim().toLowerCase().indexOf(search.trim().toLowerCase());
    if (findIndexContent !== -1) {
      const end = findIndexContent + 300;
      const endDiff = article.content.length - findIndexContent;
      const start = Math.max(findIndexContent - (endDiff < 30 ? 50 : 30), 0);
      const prepareContent = article.content.slice(start, end);

      return {
        ...article,
        category_name: findCategoryName.category_name,
        content: start > 3 ? `...${prepareContent}` : prepareContent,
      };
    }
    return { ...article, category_name: findCategoryName.category_name };
  });

export const escapeStringRegexp = (string) => {
  if (typeof string !== 'string') {
    throw new TypeError('Expected a string');
  }

  return string.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
};

export const getHighlightingText = (value, search, isHighlight = true) => {
  const valueToString = value.toString();

  if (search && isHighlight) {
    return {
      __html: valueToString.replace(new RegExp(escapeStringRegexp(search.toLowerCase()), 'gi'), (match) => `<mark>${match}</mark>`),
    };
  }
  return {
    __html: `<span>${value}</span>`,
  };
};

export const detectTab = (guides, tabPath, onSelectTab) => {
  const splitted = tabPath?.split('.');
  const categoryName = splitted?.[0];
  const article = splitted?.[1];
  const findCategory = guides?.find((g) => g.category_name.trim().toLowerCase() === categoryName?.trim()?.toLowerCase());

  if (categoryName && findCategory) {
    if (article) {
      const findArticle = findCategory?.articles?.find((c) => c.title.trim().toLowerCase() === article.trim().toLowerCase());
      findArticle && onSelectTab('categories', { ...findArticle, categoryName });
    } else {
      onSelectTab('names', findCategory);
    }
  } else {
    onSelectTab('home');
  }
};
